import React from 'react'
import styles from './CardTable.module.scss'
import cx from 'classnames'

type CardTableProps = {
  children?: React.ReactNode
  bodyClassName?: string
  tableClassName?: string
}

export const CardTable = ({
  children,
  bodyClassName,
  tableClassName,
}: CardTableProps) => (
  <table className={cx(styles.table, tableClassName)}>
    <tbody className={cx(styles.tableBody, bodyClassName)}>{children}</tbody>
  </table>
)
